// Desktop-class device: fine pointer + hover. Touch devices (phones, tablets,
// the Flutter webview) report coarse/no-hover, so this cleanly excludes them.
export function isDesktop() {
    return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
}
// Bridge to the Flutter webview host. The Vibration channel is only present
// inside the native app wrapper; on web this call no-ops.
export function vibrate(type = 'default') {
    if (type === 'default') {
        window.Vibration?.postMessage('vibrate');
    }
    else {
        window.Vibration?.postMessage(type);
    }
}
